import { render, staticRenderFns } from "./MainVallyInfo2.vue?vue&type=template&id=148e4c2e&scoped=true&"
import script from "./MainVallyInfo2.vue?vue&type=script&lang=js&"
export * from "./MainVallyInfo2.vue?vue&type=script&lang=js&"
import style0 from "./MainVallyInfo2.vue?vue&type=style&index=0&id=148e4c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e4c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
